import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { SubpageBanner, SectionHeader, Image } from 'components';
import './Banner.scss';

const Banner = () => (
  <StaticQuery
    query={graphql`
      query {
        rightBanner: file(
          relativePath: {
            eq: "career/people-discussing-on-the-office-stairs.png"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1150) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }

        leftBanner: file(relativePath: { eq: "career/office-purple.png" }) {
          childImageSharp {
            fluid(maxWidth: 209) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <SubpageBanner
        additionalClass={'career__banner'}
        backgroundColor={'pigeon-post'}
        contentBackground={'pigeon-post'}
        image={data.rightBanner.childImageSharp.fluid}
        alt={'Our office'}
      >
        <SectionHeader
          additionalClass={'text--bold'}
          color={'black'}
          headingType={1}
          lineColor={'yellow'}
          size={'large'}
        >
          <span>Careers</span>
          <br />
          <span>at Boldare</span>
        </SectionHeader>
        <div className={'image-container image--left'}>
          <Image
            src={data.leftBanner.childImageSharp.fluid}
            style={{
              objectPosition: 'top center',
            }}
          />
        </div>
      </SubpageBanner>
    )}
  />
);

export default Banner;
